import { demoCustomers, panelModes } from "@/mocks/panelContent";
import { formatBRL } from "@/lib/format";
import { PanelBadge, PanelCard, ReadOnlyNotice } from "../components/PanelUI";

const statusTone: Record<string, "primary" | "accent" | "neutral"> = {
  recorrente: "primary",
  novo: "accent",
  inativo: "neutral",
};

export default function CustomersSection() {
  return (
    <div className="flex flex-col gap-6">
      <ReadOnlyNotice text={panelModes.viewNotice} />

      <div className="rounded-lg border border-secondary-300 bg-secondary-50 px-4 py-3 text-xs leading-relaxed text-foreground-700">
        No modo público, clientes reais nunca ficam visíveis. Abaixo você vê apenas registros
        demonstrativos com dados mascarados. As informações reais ficam disponíveis
        exclusivamente para a administração Vellora, em ambiente protegido.
      </div>

      <PanelCard
        title="Clientes"
        description="A ficha é criada ou atualizada automaticamente quando a pessoa finaliza um pedido. O telefone e o e-mail evitam duplicidade."
        action={<PanelBadge tone="primary">{demoCustomers.length} exemplos</PanelBadge>}
      >
        <div className="overflow-x-auto">
          <table className="w-full min-w-[760px] border-collapse text-sm">
            <thead>
              <tr className="border-b border-background-300 text-left text-xs uppercase tracking-[0.12em] text-foreground-500">
                <th className="py-2 pr-4 font-medium">Código</th>
                <th className="py-2 pr-4 font-medium">Nome</th>
                <th className="py-2 pr-4 font-medium">WhatsApp</th>
                <th className="py-2 pr-4 font-medium">Cidade</th>
                <th className="py-2 pr-4 font-medium">Pedidos</th>
                <th className="py-2 pr-4 font-medium">Total</th>
                <th className="py-2 pr-4 font-medium">Último pedido</th>
                <th className="py-2 font-medium">Status</th>
              </tr>
            </thead>
            <tbody>
              {demoCustomers.map((customer) => (
                <tr key={customer.code} className="border-b border-background-200 last:border-0">
                  <td className="py-2.5 pr-4 text-foreground-600">{customer.code}</td>
                  <td className="py-2.5 pr-4 text-foreground-800">{customer.name}</td>
                  <td className="py-2.5 pr-4 text-foreground-600">{customer.phone}</td>
                  <td className="py-2.5 pr-4 text-foreground-600">
                    {customer.city} — {customer.state}
                  </td>
                  <td className="py-2.5 pr-4 text-foreground-600">{customer.orders}</td>
                  <td className="py-2.5 pr-4 text-foreground-600">{formatBRL(customer.totalSpent)}</td>
                  <td className="py-2.5 pr-4 text-foreground-600">{customer.lastOrderAt}</td>
                  <td className="py-2.5">
                    <PanelBadge tone={statusTone[customer.status] ?? "neutral"}>{customer.status}</PanelBadge>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="mt-4 text-[11px] leading-relaxed text-foreground-500">
          A ficha completa inclui: código, nome, telefone, e-mail, CPF (somente quando necessário),
          endereço, cidade, estado, CEP, datas do primeiro e último pedido, quantidade de pedidos,
          total comprado, produtos, tamanhos, cores, modalidade de entrega, observações, autorização
          de contato e histórico.
        </p>
      </PanelCard>
    </div>
  );
}